import React, {useContext, useEffect, useState } from 'react';
import "../Styles/SendReportCss.css";
import { DefaultButton, Spinner, SpinnerSize } from '@fluentui/react';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import SendReportBody from './SendReportBody';
import ModalMain from '../../../../components/Modal/ModalMain';
import { useSearchParams } from "react-router-dom";
import {ReportLinkSchema, AttachmentSchema, ReportAndAttachmentSchema} from './ReportLinkSchema';
import loaderContext from "../../../../context/loader/LoaderContext";
import { sendReportLink, sendReportAttachment,fetchReportLinkUrl ,viewSharedPdf, reSendReportLink, fetchFirmEmail, checkForSendReportField} from '../../../../service/StudyListService';
import toastContext from "../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../constants/Constants.jsx";
import { t } from "i18next";
import { logAmplitudeEventWithUsernameAndRole } from '../../../../helpers/Amplitude';
import userContext from '../../../../context/users/UserContext';
import { _base64ToArrayBuffer } from '../../../../service/StudyViewerService.jsx';



export const SendReportEmail = (props) => {

    const { username } = useContext(userContext);

    const [reportLink , setReportLink] = useState('');
    const [reportLinkChecked, setReportLinkChecked] = useState(false);
    const [attachmentChecked, setAttachmentChecked] = useState(false);
    const {ref, setLoaderRunning, showModal,setShowModal} = useContext(loaderContext);
    const [reportLinkEmail, setReportLinkEmail] = useState("");
    const [attachmentEmail, setAttachmentEmail] = useState("");
    const [showOnlyEmailField, setShowOnlyEmailField] = useState(false);
    const [errors, setErrors] = useState({});
    const {showToastv2} = useContext(toastContext);
    const [loadingBody,setLoadingBody] = useState(null);
    
    const studyId = props.studyId;
    const firmId = props.firmId;
    const clientId = props.clientId;
    const assignmentId = props.assignmentList[0].id;

    const appBaseUrl = window.location.origin + "/";
    const handleShareLinkCheck = async () =>{
        const new_base_url = appBaseUrl.substring(0, appBaseUrl.length - 1);
        const response = await fetchReportLinkUrl(studyId, firmId,clientId, new_base_url);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setReportLink(response.data.data.url);
        }else{
            console.log('error while fetching report link');
            // show error and close modal
        }
    }

    const handleEmailAttachmentLinkCheck = async () =>{
        let body = {
            firmId : firmId,
            clientId: clientId
        }
        const response = await fetchFirmEmail(body);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setAttachmentEmail(response.data.data);
        }else{
            console.log('error while fetching report link');
            // show error and close modal
        }
    }
    const getReportLinkPayload = ()=>{
        let payload = {
            email : reportLinkEmail,
            reportUrl : reportLink,
            reportLinkStudyId : studyId,
            mailSelected : reportLinkChecked,
        }
        return payload;
    }

    const getAttachmentPayload = () =>{
        let data = {
            studyId : studyId,
            notificationDto : {
                clientId : clientId,
                firmId : firmId,
                studyId : studyId,
                email : attachmentEmail,
                contact : "",
                assignmentId : assignmentId
             }
        }

        return data;
    }
    const handleSendReportLink = async () =>{
        setLoaderRunning(true);
        ref.current.continuousStart();

        props.setShowSendReportModal_(false);
        let payload = getReportLinkPayload();
        const response = await sendReportLink(payload);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-success"));
            
        }else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, t("send-report.error.sharing-report"));
        }
    }

    const handleSendAttachment = async ()=>{
        setLoaderRunning(true);
        ref.current.continuousStart();
        props.setShowSendReportModal_(false);

        let data = getAttachmentPayload();
        const response = await sendReportAttachment(data);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.send-report-success"));
        } else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, response.data.message);
        }
    }

    const handleSendReportAndAttachment = async () =>{
        setLoaderRunning(true);
        ref.current.continuousStart();

        props.setShowSendReportModal_(false);

        let response1 = await sendReportLink(getReportLinkPayload());
        let response2 = await sendReportAttachment(getAttachmentPayload());

        let eventProperties = {
            "STUDY ID": studyId,
          };
          

        if(response1.status === 200 && response2.status === 200){
            if(response1.data.result === "SUCCESS" && response2.data.result === "SUCCESS"){
                setLoaderRunning(false);
                ref.current.complete();
                showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-attachment-success"));
            }
            logAmplitudeEventWithUsernameAndRole(
                "EVENT_BASIC_EMAIL_REPORT",
                eventProperties,
                username
              );
        }else if(response1.status === 200 && response1.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-link-send-success"));
            logAmplitudeEventWithUsernameAndRole(
                "EVENT_BASIC_EMAIL_REPORT",
                eventProperties,
                username
              );

        }else if(response1.status === 200 && response1.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.attachment-send-success"));
            logAmplitudeEventWithUsernameAndRole(
                "EVENT_BASIC_EMAIL_REPORT",
                eventProperties,
                username
              );
        }
    }
    useEffect(() => {
        if(reportLinkChecked){
            handleShareLinkCheck();
        }
    }, [reportLinkChecked]);

    useEffect(() => {
        if(attachmentChecked && (props.assignmentChain == null || props.assignmentChain == undefined)){
            handleEmailAttachmentLinkCheck();
        }else{
            setAttachmentEmail("");
        }
    }, [attachmentChecked]);

    const checkForEnableAllField = async() => {
        setLoadingBody(true);
        setLoaderRunning(true);
        ref.current.continuousStart();

        const response = await checkForSendReportField({firmId:props.firmId});
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            console.log("--- Value ---",response);
            if(response?.data?.data == false){
                setShowOnlyEmailField(true);
                setAttachmentChecked(true);
                handleEmailAttachmentLinkCheck();
            }
            setLoadingBody(false);
            setLoaderRunning(false);
            ref.current.complete();
        }else{
            showToastv2(TOAST_TYPE.ERROR, t("string-literals.failed-message"));
            setLoaderRunning(false);
            setLoadingBody(false);
            ref.current.complete();
        }
    }


    useEffect(()=>{
        if(props.firmId != null && props.firmId != undefined){
            console.log("--- Running useEffect of send report modal ----");
            checkForEnableAllField()
        }
        
    },[])

    const handleClose = ()=>{
        props.setShowSendReportModal_(false);
    }

    const validateAndSubmit = (schema, values, callbackfn) =>{
        schema.validate(values, { abortEarly: false })
            .then(() => {
                callbackfn();
            })
            .catch((validationErrors) => {
              const errors = validationErrors.inner.reduce(
                (acc, error) => ({ ...acc, [error.path]: error.message }),
                {}
            );
            setErrors(errors);
        });
    }

    const handleSubmit = () =>{
        console.log("--- Handle Submit ----");
        if(reportLinkChecked && attachmentChecked){
            const validationFields = {
                reportEmail : reportLinkEmail,
                attachmentEmail : attachmentEmail
            }
            validateAndSubmit(ReportAndAttachmentSchema, validationFields, handleSendReportAndAttachment);
        }else if(reportLinkChecked){

            validateAndSubmit(ReportLinkSchema, {reportEmail : reportLinkEmail}, handleSendReportLink);
        }else if(attachmentChecked){

            validateAndSubmit(AttachmentSchema, {attachmentEmail : attachmentEmail}, handleSendAttachment);
        }else{
            props.setShowSendReportModal_(false);
        }
    }

    let PrimaryButtonList = [
        {
            title:"Send",
            onclick: handleSubmit,
        }
    ];
    let DefaultButtonList = [
        {
            title:"Cancel",
            onclick: handleClose
        }
    ];

    const spinnerStyle = {
        circle: {
          height: "30px",
          width: "30px",
          borderWidth: "5px",
        }
      }

    const modalDetails = {
        header: <ModalHeader updatedModal={true} showPatientDetails={false} heading={t("heading.send-report")} handleCancel={handleClose}/>,
        footer : <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={PrimaryButtonList}/>,
        body : (loadingBody != null && !loadingBody) ?<SendReportBody showOnlyEmailField={showOnlyEmailField} handleShareLinkCheck = {handleShareLinkCheck} handleEmailAttachmentLinkCheck={handleEmailAttachmentLinkCheck}  reportLink = {reportLink} setAttachmentChecked = {setAttachmentChecked}
                setReportLinkChecked = {setReportLinkChecked} reportLinkChecked = {reportLinkChecked} attachmentChecked = {attachmentChecked}
                attachmentEmail = {attachmentEmail} setReportLink={setReportLink} reportLinkEmail={reportLinkEmail} setReportLinkEmail = {setReportLinkEmail} setAttachmentEmail = {setAttachmentEmail} 
                errors = {errors}/>:
                <>
                <div style={{padding:'30px 30px'}}><Spinner size={SpinnerSize.large} styles={spinnerStyle}/></div>
                </>,
        width : "500px",
        height: "360px",
      }

  return (
    <>
        <ModalMain updatedModal={true} showModal={true} modalDetails={modalDetails} />
    </>
  )
}


export const SharedReport = ()=>{
    const [searchParams] = useSearchParams();
    const [pdfUrl, setPdfUrl] = useState("");
    const [expiredLink, setExpiredLink] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [disableResendButton, setDisableResendButton] = useState(false);
    const {ref, setLoaderRunning, showModal,setShowModal} = useContext(loaderContext);
    const {showToastv2} = useContext(toastContext);

    useEffect(() => {
        document.title = "View";
      }, []);

    useEffect(() => {
       
        async function fetchPdf () {
            setLoaderRunning(true);
            ref.current.continuousStart();
    

            let encrypted_id = searchParams.get("q");

           try{ const response = await viewSharedPdf(encrypted_id);
            if(response.status === 200){
                if(response.data.result && response.data.result === "FAILURE"){
                    console.log('rs', response.data.message);
                    setExpiredLink(true);
                    setUserEmail(response.data.data);
                    setLoaderRunning(false);
                    ref.current.complete();
                    setShowModal(() => {
                        const newItem = { ...showModal };
                        newItem.show = true;
                        newItem.heading = "Error";
                        newItem.description = t("string-literals.error-msg");
                        return newItem;
                      });
                }else{
                    console.log('pdf response loaded successfully!!',response);
                    const fileData = _base64ToArrayBuffer(response?.data?.data?.data);
                    const pdfBlob = new Blob([fileData], { type: 'application/pdf' });
                    const c_pdfUrl = URL.createObjectURL(pdfBlob);
                    setPdfUrl(c_pdfUrl);
                    setLoaderRunning(false);
                    ref.current.complete();
                }
            }else{
                setLoaderRunning(false);
                ref.current.complete();
                setShowModal(() => {
                    const newItem = { ...showModal };
                    newItem.show = true;
                    newItem.heading = "Error";
                    newItem.description = t("string-literals.error-msg");
                    return newItem;
                  });
            }
        }catch(e){
            console.log("--- Error ---",e);
                setLoaderRunning(false);
                ref.current.complete();
                setShowModal(() => {
                    const newItem = { ...showModal };
                    newItem.show = true;
                    newItem.heading = "Error";
                    newItem.description = t("string-literals.error-msg");
                    return newItem;
                  });
            }
        }
        fetchPdf();
      }, []);

      const handleResendLink = async () =>{

        setLoaderRunning(true);
        ref.current.continuousStart();

        let encrypted_id = searchParams.get("q");
        const appBaseUrl = window.location.origin + "/";
        const payload = {
            encryptedLink : encrypted_id, 
            baseUrl : appBaseUrl.substring(0, appBaseUrl.length - 1)
        }

        const response = await reSendReportLink(payload);
        if(response.status === 200 && response.data.result === 'SUCCESS'){
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.SUCCESS, t("send-report.report-reshared"));
            setDisableResendButton(true);
        }else{
            setLoaderRunning(false);
            ref.current.complete();
            showToastv2(TOAST_TYPE.ERROR, t("send-report.error.resharing-report"));
        }
      }

      return (
        <div style={{height : "100%",display:'flex',alignItems:'center',justifyContent:'center'}}>
          {
            expiredLink ? (
              <div>
                {userEmail !== "" && 
                    <div>
                        <p style={{textAlign : "center"}}>{t("send-report.report-link-expired")}</p>
                        <p style={{textAlign : "center"}}>{t("send-report.new-link")}
                                 <DefaultButton text={"button.click"} disabled = {disableResendButton} onClick={handleResendLink}></DefaultButton>  </p>
                    </div>
                }
                { userEmail === "" && 
                    <div> 
                        <p style={{textAlign : "center"}}>{t("send-report.report-link-expired")}</p>
                        <p style={{textAlign : "center"}}>{t("send-report.contact-support-new-url")}</p>
                    </div>
                }
              </div>
            ) : pdfUrl ? (
                <embed src={pdfUrl} type="application/pdf" width="100%" height="99%" />
              ) : (
                <p style={{textAlign : "center"}}>{t("send-report.loading-pdf")}</p>
              )
         }
        </div>
    );

}